export enum AccessLevel {
   NONE = 'No Access',
   ASSIGNED = 'Assigned Items Only',
   ALL = 'All Items',
}
